import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
} from '@angular/core';
import { AbstractContentInitializer } from '../../../cross-team-shared/abstract-content-initializer';
import { makeToolProviders } from '../../../cross-team-shared/annotation/shared/abstract-tool';
import { AbstractSensorContentStore } from '../../../cross-team-shared/state/abstract-sensor-content-store';
import { AbstractAssetInitializationService } from '../../shared/asset-loading/abstract-asset-initialization.service';
import { contentProviders2D } from '../../shared/content-providers-2d';
import { AbstractSensorContentStore2D } from '../../shared/state/abstract-sensor-content-store-2d';
import { ImageContentConnector } from '../image-content-connector';
import { ColorSelectTool } from '../raster-tools/color-select-tool/color-select-tool.service';
import { FloodfillTool } from '../raster-tools/floodfill-tool/floodfill-tool';
import { PaintbrushTool } from '../raster-tools/paintbrush-tool/paintbrush-tool';
import { SuperpixelTool } from '../raster-tools/superpixel-tool/superpixel-tool';
import { ImageContentState } from '../state/image-content-state';
import { ImageContentStateUndoService } from '../state/image-content-state-undo.service';
import { ImageContentStore } from '../state/image-content-store';
import { ImageAssetInitializationService } from '../utils/loading/image-asset-initialization.service';
import { RasterMaskSavingService } from '../utils/raster-mask-saving.service';
import { ImageLayerSettingsService } from './image-layer-settings.service';

@Component({
  selector: 'h3-image-content-initializer',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    contentProviders2D,
    makeToolProviders(
      ColorSelectTool,
      FloodfillTool,
      PaintbrushTool,
      SuperpixelTool,
    ),
    ImageAssetInitializationService,
    ImageLayerSettingsService,
    RasterMaskSavingService,
    {
      provide: AbstractAssetInitializationService,
      useExisting: ImageAssetInitializationService,
    },
    {
      provide: ImageContentStore,
      useFactory: () => new ImageContentStore(new ImageContentState()),
    },
    ImageContentStateUndoService,
    { provide: AbstractSensorContentStore, useExisting: ImageContentStore },
    { provide: AbstractSensorContentStore2D, useExisting: ImageContentStore },
    ImageContentConnector,
  ],
  standalone: false,
})
export class ImageContentInitializerComponent
  extends AbstractContentInitializer<ImageContentConnector>
  implements OnInit
{
  constructor(
    injector: Injector,
    protected override store: ImageContentStore,
    private layerSettingsService: ImageLayerSettingsService,
  ) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();

    if (!this.store.state().project.use_annotation_store) {
      this.injector
        .get(ImageContentStore)('layerSettings')
        .set(this.layerSettingsService.getInitialSettings());
    }
  }

  protected getContentConnector() {
    return this.injector.get(ImageContentConnector);
  }

  protected override setUpSubscriptions(store: AbstractSensorContentStore) {
    super.setUpSubscriptions(store);
    if (this.store.state().project.use_annotation_store) {
      throw new Error('Implement raster settings with objects.');
    }

    this.subscribeTo(this.settingsStore('viewMode').$, (viewMode) =>
      this.store('viewMode').set(viewMode),
    );
  }
}
